import { COLORS, SEAT_SIZE } from '../constants';
import { Group } from 'konva/lib/Group';
import { Circle } from 'konva/lib/shapes/Circle';
import { Rect } from 'konva/lib/shapes/Rect';

class TableRect {
	options: any = {};
	draggable = true;
	element = new Group({
		draggable: true,
	});
	shape: any;
	seats: any;
	private sizes: any = {
		s: {
			width: 75,
            height: 50,
		},
        m: {
			width: 105,
            height: 70,
		},
        l: {
			width: 135,
            height: 90,
		},
	}

	constructor(options = {}) {
		this.options = options;

		this.initShape();
		this.initSeats();
		this.reorder();
	}

	private initShape() {
		const size: any = this.sizes[`${this.options.size}`]; 
		this.shape = new Rect({
			x: 0,
			y: 0,
			width: size.width,
			height: size.height,
			fill: 'white',
			stroke: 'black',
			strokeWidth: 2,
			cornerRadius: 2,
		});

		this.element.add(this.shape);
	}

	private initSeats() {
		let seats = new Group({name: 'seats'});
		this.seats = seats;

		let fakeCapacity = 6
		for (let i = 0; i < fakeCapacity; i++) {
			const seat = new Circle({
				x: 0,
				y: 0,
				radius: SEAT_SIZE,
				fill: COLORS.SEATS.INACTIVE,
			});

			seats.add(seat);
		}

		this.placeSeats();
		this.removeUnusedSeats();

		this.element.add(seats);
	}

	private placeSeats() {
		let seats = this.seats.children;
		// let fakeCapacity = 6
		// let seatsOnSide = (fakeCapacity - 2) / 2;
		let shapeWidth = this.shape.width();
		let shapeHeight = this.shape.height();
		let size = this.options.size;
		let offsets: any = {
			s: { start: 20 , step: 35 },
			m: { start: 30 , step: 45 },
			l: { start: 37 , step: 60 },
        };



		seats.forEach((seat: any, i: number) => {
			if(i == 0){
				seats[0].y(shapeHeight / 2);
			}
			if(i == 1){
				seats[1].x(shapeWidth);
				seats[1].y(shapeHeight / 2);
			}
			if(i >= 2){
				seat.x(offsets[`${size}`].start + (offsets[`${size}`].step * (i - 2)))
			}
			if(i >= 4){
				seat.x(offsets[`${size}`].start + (offsets[`${size}`].step * (i - 4)))
				seat.y(shapeHeight);
			}
		});
	}

	private removeUnusedSeats(){
		if(this.options.capacity == 4){
			this.seats.children[0].destroy();
			this.seats.children[0].destroy();
		} else if (this.options.capacity == 3){
			this.seats.children[0].destroy();
			this.seats.children[3].destroy();
			this.seats.children[3].destroy();
		}
		else if(this.options.capacity == 5){
			this.seats.children[0].destroy();
		}
		else if(this.options.capacity == 2){
            this.seats.children[0].destroy();
            this.seats.children[0].destroy();
            this.seats.children[2].destroy();
            this.seats.children[2].destroy();
        }
	}

	private reorder() {
		this.element.children[1].zIndex(0);
	}
}

export default TableRect;
